/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { useState, useEffect, useCallback, useContext, forwardRef, MutableRefObject } from "react";
import { TextField, Button } from "@material-ui/core";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../../../../../constants/caption/dashboardHeader";
import { PersonalInformation, EmployerSection, BenefitSelection, HeaderInformation } from "../../../../../../..";

import SendIcon from "@material-ui/icons/Send";

import "./lincolnFormPrint.css";
import { LincolnFormType } from "../../../../../../../../../@types/lincolnForm.types";
import prefixCharacterAddition from "../../../../../../../../../utils/commonFunctions/prefixCharacterAddition";

const LincolnFormPrint = forwardRef(
	({ employee, employerSection, totalPremium, enrollmentDate, effectiveDate }: any, ref: any) => {
		return (
			<div className="lincoln-form-print" id="lincoln-form-print" ref={ref}>
				<div className="header-information" id="header-information">
					<HeaderInformation isPrintable={true} />
				</div>
				<div className="header-container" id="header-container">
					<div className="form-header" id="form-header">
						<span className="header-number" id="header-number">
							1.
						</span>
						Your Personal Information
					</div>
					<div className="personal-informations" id="personal-informations">
						<PersonalInformation
							employee={employee}
							//handleEnrollmentChange={handleEnrollmentChange}
							//handleDateOfBirthChange={handleDateOfBirthChange}
							//handleRadioChange={handleRadioChange}
							isPrintable={true}
						/>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<div className="header-container" id="header-container">
					<EmployerSection
						employerSection={employerSection}
						//handleEnrollmentChange={handleEnrollmentChange}
						//handleEnrollmentDateChange={handleEnrollmentDateChange}
						//handleRehireDateChange={handleRehireDateChange}
						//handleCheck={handleCheck}
						isPrintable={true}
					/>
				</div>
				<div className="header-container" id="header-container">
					<div className="form-header" id="form-header">
						<span className="header-number" id="header-number">
							2.
						</span>
						Benefit Selection - Choose your benefits
					</div>
					<div className="benefit-selections" id="benefit-selections">
						<BenefitSelection
							totalPremium={totalPremium as number}
							effectiveDate={effectiveDate}
							// handleEnrollmentChange={handleEnrollmentChange}
							// handleEffectiveDateChange={handleEffectiveDateChange}
							// handleBuyUpLTDCheck={handleBuyUpLTDCheck}
							isPrintable={true}
						/>
					</div>
				</div>
				<div className="header-container" id="header-container">
					<div className="form-header" id="form-header">
						<span className="header-number" id="header-number">
							3.
						</span>
						Confirm Enrollment
					</div>
					<p className="warning-container">
						This group insurance has been offered to me and after careful consideration of the benefits, I
						have decided to:
					</p>
					<div className="checkbox-container">
						<span className="checkbox">
							<input
								type="checkbox"
								id="enroll_insurance"
								name="enroll_insurance"
								//onChange={handleEnrollCheck}
								// checked={lincolnForm?.enroll_insurance}
								checked={true}
							/>
						</span>
						<span className="enroll-text">ENROLL FOR INSURANCE for which I am or may become eligible </span>
						<span className="enroll-text1">under the group policies issued by </span>
						<div className="paragraph-text1">The Lincoln National Life. </div>
						<p className="paragraph-text2">
							Insurance Company, or its insurance partners. If contributions are required, I authorize my
							Employer to deduct premium from my pay.
						</p>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<br />
				<br />
				<div className="warning-header-container" id="warning-header-container">
					<div className="form-header" id="form-header">
						<span className="header-number" id="header-number">
							4.
						</span>
						Fraud Warning/State Disclosure(s)
					</div>
					<p className="warning-container">
						ANY PERSON WHO KNOWINGLY PRESENTS A FALSE OR FRAUDULENT CLAIM FOR THE PAYMENT OF A LOSS IS
						GUILTY OF A CRIME AND MAY BE SUBJECT TO FINES AND CONFINEMENT IN STATE PRISON.
					</p>
				</div>
				<div className="header-container" id="header-container">
					<div className="form-header" id="form-header">
						<span className="header-number" id="header-number">
							5.
						</span>
						Sign & Return
					</div>
					<p className="paragraph-container">
						I understand the group insurance requested will not be effective until approved by the Group
						Insurance Service Office of The Lincoln National Life Insurance Company, or its insurance
						partners. A delayed effective date will apply if you are not Actively at Work/an Active Member.
						A delayed effective date may apply to your dependent, if he or she is confirmed in a hospital or
						health care facility or is in a period of limited actively on the date insurance would otherwise
						take effect.
					</p>
					<p className="paragraph-container">
						I understand the information provided is for enrollment in group insurance as offered by my
						Employer and will not be used for underwriting purposes.
					</p>
					<p className="paragraph-container">
						The information provided is complete, true, and accurate to the best of my knowledge.
					</p>
					<div className="fullname-container">
						<span className="fullname-header">Your Full Name (Print):</span>
						<span className="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="full_name"
								value={employee.first_name + " " + employee.middle_name + " " + employee.last_name}
								style={{
									width: "395px",
									borderRadius: 50
								}}
							/>
						</span>
					</div>
					<div className="signature-container">
						<span className="signature-header">Your Signature:</span>
						<span className="textfield-container">
							<TextField
								className="text-field"
								id="text-field"
								name="signature"
								value={
									employee.first_name +
									" " +
									(employee.middle_name ? employee.middle_name : "") +
									" " +
									employee.last_name
								}
								style={{
									width: "398px",
									borderRadius: 50
								}}
							/>
						</span>
						<span className="date-header">Date:</span>
						<span className="date-container">
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									placeholder="MM"
									name="month"
									value={
										enrollmentDate
											? prefixCharacterAddition(new Date(enrollmentDate).getMonth() + 1)
											: ""
									}
									style={{
										width: "30px",
										borderRadius: 50
									}}
								/>
							</span>
							/
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									placeholder="DD"
									name="day"
									value={
										enrollmentDate
											? prefixCharacterAddition(new Date(enrollmentDate).getDate())
											: ""
									}
									//onChange={handleDateChange}
									style={{
										marginLeft: "3px",
										width: "30px",
										borderRadius: 50
									}}
								/>
							</span>
							/
							<span className="textfield-container">
								<TextField
									className="date-field"
									id="text-field"
									placeholder="YYYY"
									name="year"
									value={
										enrollmentDate
											? prefixCharacterAddition(new Date(enrollmentDate).getFullYear())
											: ""
									}
									//onChange={handleDateChange}
									style={{
										marginLeft: "3px",
										width: "45px",
										borderRadius: 50
									}}
								/>
							</span>
						</span>
					</div>
				</div>
				<div className="footer-container" id="footer-container">
					<div className="return-container" id="return-container">
						Complete and return this form.
					</div>
					<div className="note-container" id="note-container">
						(Be sure to sign and date the form to start your insurance.)
					</div>
					<div className="contact-container" id="contact-container">
						Questions? Call 800-423-2765
					</div>
				</div>
			</div>
		);
	}
);

export default LincolnFormPrint;
